import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";

export abstract class PrebidJsBaseBidder implements IPrebidJsBidder<unknown> {
    public constructor(protected config: HeaderBiddingConfig, protected bidder: Bidders) {
    }

    public getAdUnit(id: number): any {
        const adUnit = this.config.adUnits.find((adUnit) => adUnit.id === id);
        if (!adUnit || !adUnit.bidders[this.bidder]) {
            return undefined;
        }
        return {bidder: this.bidder, params: adUnit.bidders[this.bidder]};
    }

    public getBidderSettings(): Record<string, any> | undefined {
        const multiplier = this.config.biddersConfig?.[this.bidder]?.multiplier || null;
        const config = this.config.biddersConfig?.[this.bidder]?.config || null;

        const parsedConfig: any = {};

        if (multiplier !== null) {
            parsedConfig['bidCpmAdjustment'] = function (bidCpm: number) {
                return bidCpm * multiplier;
            };
        }

        if (config !== null) {
            Object.keys(config).forEach((key) => {
                parsedConfig[key] = config[key];
            });
        }

        if (!parsedConfig) {
            return undefined;
        }

        return {
            [this.bidder]: parsedConfig
        };
    }
}
